import React, { useState, useEffect, useContext } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import { observer } from 'mobx-react';
import { useStore } from '../../sdo.js'
import {useNavigate} from "react-router-dom";
import sso from "../../sso";

function Ta_Menu(props) {
    var navigate = useNavigate();
    let [state, setState] = useState({row: {}, htitle: "", ma: []});
    let ctx = useStore();

    var lock = "lock";
    var moa = {};
    moa["f00"] = { fid: "f00", name: "Hem", url: "/ta", icon: "home", fa: "fa fa-home flex", ma: [] };
    moa["f01"] = { fid: "f01", name: "Personal", url: "/ta/ee", icon: "key", fa: "fa fa-key flex", ma: [] };
    moa["f02"] = { fid: "f02", name: "Schema", url: "/ta/shd", icon: "play", fa: "fa fa-play flex", ma: [] };
    moa["f03"] = { fid: "f03", name: "Pass", url: "/ta/pass", icon: "chalkboard", fa: "fa fa-chart-bar flex", ma: [] };
    moa["f04"] = { fid: "f04", name: "Tider", url: "/ta/th", icon: "calendar-alt", fa: "fa fa-chart-bar flex", ma: [] };
    moa["f05"] = { fid: "f05", name: "Kalkyl", url: "/ta/calc", icon: "chart-line", fa: "fa fa-chart-bar flex", ma: [] };
    moa["f06"] = { fid: "f06", name: "Rapporter", url: "/ta/rps", icon: "chart-bar", fa: "fa fa-chart-bar flex", ma: [] };
    moa["f09"] = { fid: "f09", name: "Backoffice", url: "/ta/bo", icon: "cogs", fa: "fa fa-cogs flex", ma: [] };

    moa["f01"].ma.push( { fid: "f01", name: "Personallista", url: "/ta/ee/prs", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "f01", name: "Avdelningsvis", url: "/ta/ee/dep", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "f01", name: "Lönehantering", url: "/ta/ee/sal", fa: "fa fa-bars" } );

    moa["f02"].ma.push( { fid: "f02", name: "Basschema", url: "/ta/shd/bas", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "f02", name: "Personal", url: "/ta/shd/prs", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "f02", name: "Avdelningar", url: "/ta/shd/dep", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "f02", name: "Veckoschema", url: "/ta/shd/week", fa: "fa fa-bars" } );

    moa["f03"].ma.push( { fid: "f03", name: "Veckopass", url: "/ta/pass/week", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "f03", name: "Passschema", url: "/ta/pass/shd", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "f03", name: "Passplan", url: "/ta/pass/plan", fa: "fa fa-bars" } );

    moa["f04"].ma.push( { fid: "f04", name: "Aktiva", url: "/ta/th/act", fa: "fa fa-bars" } );
    moa["f04"].ma.push( { fid: "f04", name: "Period", url: "/ta/th/per", fa: "fa fa-bars" } );
    moa["f04"].ma.push( { fid: "f04", name: "Avdelningar", url: "/ta/th/avd", fa: "fa fa-bars" } );
    moa["f04"].ma.push( { fid: "f04", name: "Transaktioner", url: "/ta/th/trs", fa: "fa fa-bars" } );
    moa["f04"].ma.push( { fid: "f04", name: "Dag", url: "/ta/th/day", fa: "fa fa-bars" } );
    moa["f04"].ma.push( { fid: "f04", name: "Vecka", url: "/ta/th/week", fa: "fa fa-bars" } );

    moa["f05"].ma.push( { fid: "f05", name: "Total", url: "/ta/calc/tot", fa: "fa fa-bars" } );
    moa["f05"].ma.push( { fid: "f05", name: "Avdelning", url: "/ta/calc/avd", fa: "fa fa-bars" } );
    moa["f05"].ma.push( { fid: "f05", name: "Dag", url: "/ta/calc/day", fa: "fa fa-bars" } );
    moa["f05"].ma.push( { fid: "f05", name: "Period", url: "/ta/calc/per", fa: "fa fa-bars" } );

    moa["f06"].ma.push( { fid: "f06", name: "Rapporter", url: "/ta/rps/rps", fa: "fa fa-bars" } );
    moa["f06"].ma.push( { fid: "f06", name: "Register", url: "/ta/rps/reg", fa: "fa fa-bars" } );
    moa["f06"].ma.push( { fid: "f06", name: "Lönelistor", url: "/ta/rps/sal", fa: "fa fa-bars" } );

    moa["f09"].ma.push( { fid: "f09", name: "Företag", url: "/ta/bo/ftg", fa: "fa fa-bars" } );
    moa["f09"].ma.push( { fid: "f09", name: "Parametrar", url: "/ta/bo/prm", fa: "fa fa-bars" } );
    moa["f09"].ma.push( { fid: "f09", name: "Avdelningar", url: "/ta/bo/dep", fa: "fa fa-bars" } );
    moa["f09"].ma.push( { fid: "f09", name: "Kategorier", url: "/ta/bo/cat", fa: "fa fa-bars" } );
    moa["f09"].ma.push( { fid: "f09", name: "Röda dagar", url: "/ta/bo/red", fa: "fa fa-bars" } );
    moa["f09"].ma.push( { fid: "f09", name: "Anledningar", url: "/ta/bo/reason", fa: "fa fa-bars" } );

    var aa = [];
    var keys = Object.keys(moa);
    for(var key of keys) {
        var o = moa[key];
        aa.push( o );
    }

    var ma = [];
    var mnuHeight = window.innerHeight - 100;

   function fknGo(row) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    var fkn = row.fid;
    setState({ row : row,  ma : [] });
    ctx.fid = fkn;

       sso.seo.sfkn = row;
    //props.store.fkn = row;

       navigate(row.url);
   };
   function fknFix(fkn) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    ctx.fid = fkn;

    if(fkn == "lock") navigate('/web');
    if(fkn == "logout") navigate('/');
   };
   function mnuGo(row) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    //ctx.fid = fkn;
    var fkn = row.fid;
    setState({ row : row,  ma : [] });
    ctx.fid = fkn;

       sso.seo.sfkn = row;
    //props.store.fkn = row;

       navigate(row.url);
   };
   function hideMnu() {
    setState({row : state.row, ma : [] });
   };
   function mouseEnter(it) {
    setState({row : state.row, htitle : it.name, ma : it.ma });
   };
   function mouseLeave() {
    setState({row : state.row, ma : [] });
   };

   function row_css(row) {
  	    var css = {};
        css.margin = "0px";
        css.padding = "0px";
        css.height = "55px";
        css.borderBottom = "1px #ccc solid";

		if(state.row) {
		if(state.row.fid == row.fid) {
			css.background = "#080";
			css.color = "#fff";
		}
		}
		return css;
    }
    function row_icon_css(row) {
  	    var css = {};
        css.paddingTop = "10px";
        css.fontSize = "20px";

		if(state.row) {
		if(state.row.fid == row.fid) {
			//css.color = "#ff9900";
			css.color = "#fff";
		}
		}
		return css;
    }

   //<Icon className={ it.fa } style={{ fontSize: 18 }} />
   var html =
        <div className="">
        <div className="cdi_xmnu flex-fullcol" style={{padding: "5px 0px"}}>
            { aa.map((it, key) =>
            <div key={ key } onClick={() => fknGo(it)} className="web-col flex-cc xmnu_tab" style={ row_css(it) } onMouseEnter={ () => mouseEnter(it) }>
                <FontAwesomeIcon icon={ it.icon } size="1x" className="" style={ row_icon_css(it) } />
                <div style={{fontSize: "10px"}}>{ it.name }</div>
            </div>
            )}
            <div onClick={ () => fknFix("lock") } className="web-col flex-cc xmnu_tab">
                <FontAwesomeIcon icon="lock" size="1x" className="" style={{paddingTop: "10px", fontSize: "20px"}} />
                <div style={{fontSize: "10px"}}>Lås</div>
            </div>
            <div onClick={() => fknFix("logout") } className="web-col flex-cc xmnu_tab" >
                <i className="fa fa-power-off flex" aria-hidden="true" style={{paddingTop: "10px", fontSize: "20px"}}></i>
                <div style={{fontSize: "10px"}}>Logga ur</div>
            </div>
        </div>

            { state.ma.length ?
        <div className="mtrl_mnu_sub mtrl_mnu_bg" aria-label="Sub Menu" style={{height: mnuHeight}} onMouseLeave={mouseLeave}>
          <div className="mtrl_mnu_title" onClick={() => hideMnu()}>
            { state.htitle }
          </div>
            { state.ma.map((mi, key) =>
          <div key={key} className="mtrl_mnu_item flex-row" onClick={ () => mnuGo(mi) }>
            <div className="flex">{ mi.name }</div>
            <i className={ mi.fa } aria-hidden="true" style={ row_icon_css(mi) }></i>
          </div>
            )}
        </div>
                : null }
        </div>
    ;
    return html;
}

export default observer(Ta_Menu);
